var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconErrorRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.71625 0 0 6.71625 0 15C0 23.2838 6.71625 30 15 30C23.2838 30 30 23.2838 30 15C30 6.71625 23.2838 0 15 0ZM13.3113 8.11625C13.2113 7.115 13.9987 6.25 15 6.25C16.0012 6.25 16.7887 7.115 16.6887 8.11625L15.6875 18.1287C15.6512 18.4813 15.355 18.75 15 18.75C14.645 18.75 14.3488 18.4813 14.3125 18.1275L13.3113 8.11625ZM15 24.0625C14.1375 24.0625 13.4375 23.3625 13.4375 22.5C13.4375 21.6375 14.1375 20.9375 15 20.9375C15.8625 20.9375 16.5625 21.6375 16.5625 22.5C16.5625 23.3625 15.8625 24.0625 15 24.0625Z",
    fill: "#E44829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorRed);
export default __webpack_public_path__ + "static/media/icon-error-red.f619bfaa03f570615a9c0503c1db4aa9.svg";
export { ForwardRef as ReactComponent };